import { HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader, TranslocoModule, provideTransloco } from '@jsverse/transloco';
import { inject, Injectable, NgModule } from '@angular/core';
import { environment } from '../environments/environment';
import { TranslationKeeperService } from './services/translation-keeper.service';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  constructor(
    // private http: HttpClient,
    private translationKeeper: TranslationKeeperService
  ) {}

  getTranslation(lang: string) {
    if (lang === 'de') {
      return this.http.get<Translation>(`./assets/i18n/${lang}.json`);
    } else {
      return of(this.translationKeeper.getTranslations()[lang]);
    }
  }

}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: ['de'],
        defaultLang: 'de',
        reRenderOnLangChange: true,
        prodMode: environment.production
      },
      loader: TranslocoHttpLoader
    })
  ]
})
export class TranslocoRootModule {}
